// extracted by mini-css-extract-plugin
export var subtitle = "_d0-2";
export var title = "_d0-0";
export var titleNoWrap = "_d0-1";